import { HeadCellType } from 'components/Common/DeprecatedTableHead';

export const ContactNoteHeadCells = [
  {
    id: 'startDateTime',
    numeric: false,
    disablePadding: false,
    label: 'Contact date',
    type: HeadCellType.SORT,
  },
  {
    id: 'subject',
    numeric: false,
    disablePadding: false,
    label: 'Subject',
    type: HeadCellType.SORT,
  },
  {
    id: 'contactType',
    numeric: false,
    disablePadding: false,
    label: 'Contact type',
    type: HeadCellType.FILTER,
  },
  {
    id: 'source',
    numeric: false,
    disablePadding: false,
    label: 'Source',
    type: HeadCellType.FILTER,
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: 'Status',
    type: HeadCellType.SORT,
  },
  {
    id: 'contactNoteId',
    numeric: false,
    disablePadding: false,
    label: 'CLM ID',
    type: HeadCellType.FILTER,
  },
];

//TO be included in zafire
export const ContactNoteZafireHeadCells = [
  { id: 'contactNoteId', numeric: false, disablePadding: false, label: 'Contact note id', type: HeadCellType.FILTER },
  {
    id: 'startDateTime',
    numeric: false,
    disablePadding: false,
    label: 'Contact date',
    type: HeadCellType.SORT,
  },
  {
    id: 'relatedPartners',
    numeric: false,
    disablePadding: false,
    label: 'Client representatives',
    type: HeadCellType.FILTER,
  },
  {
    id: 'relatedBRs',
    numeric: false,
    disablePadding: false,
    label: 'Business relationship(s)',
    type: HeadCellType.FILTER,
  },
  {
    id: 'subject',
    numeric: false,
    disablePadding: false,
    label: 'Subject',
    type: HeadCellType.SORT,
  },
  {
    id: 'notes',
    numeric: false,
    disablePadding: false,
    label: 'Notes',
    type: HeadCellType.SORT,
  },
  {
    id: 'contactType',
    numeric: false,
    disablePadding: false,
    label: 'Communication channel',
    type: HeadCellType.FILTER,
  },
  {
    id: 'createdByFullName',
    numeric: false,
    disablePadding: false,
    label: 'Creator',
    type: HeadCellType.FILTER,
  },
  {
    id: 'source',
    numeric: false,
    disablePadding: false,
    label: 'Source',
    type: HeadCellType.FILTER,
  },
  {
    id: 'tripId',
    numeric: false,
    disablePadding: false,
    label: 'Trip id',
    type: HeadCellType.FILTER,
  },
  {
    id: 'attachments',
    numeric: false,
    disablePadding: false,
    label: 'Doc available',
    type: HeadCellType.SORT,
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: 'Status',
    type: HeadCellType.FILTER,
  },
];

//Table displays the column (Created, Partner, Subject, Contact Type, Responsible RM)
export const ContactNoteTeamViewHeadCells: any = [
  ...ContactNoteHeadCells.slice(0, -1),
  {
    id: 'responsibleRmFullName',
    numeric: false,
    disablePadding: false,
    label: 'Responsible RM',
    type: HeadCellType.SORT,
  },
];
